import React, { Component } from "react";
import PropTypes from "prop-types";
import "./RiskRangeChart.style.scss";

class RiskRangeChart extends Component {
  state = {
    rangecolors: ["#C5DD03", "#70AD47", "#FF9300", "#C55A11", "#FFFD78"],
    colors: ["#009144", "#c5dd03", "#f5ee00", "#ffa103", "#ef011b"],
    percentage: 0,
    slider_color: 0,
    riskCapacityScore: 0,
    riskPreferenceScore: 0,
    riskCapacityPercentage: 0,
    riskPreferencePercentage: 0,
    riskCapacityColor: 0,
    riskPreferenceColor: 0,
  };

  componentDidMount() {
    const {
      min,
      max,
      value,
      percentage,
      dualNotch,
      riskCapacityScore,
      riskPreferenceScore,
    } = this.props;

    this.caluculation({ min: min * 1, max: max * 1, value: value * 1 });

    if (percentage) {
      let slider_color = this.getSliderColorIndex({ percentage });
      this.setState({
        percentage,
        slider_color,
      });
    }

    if (dualNotch) {
      this.setState({
        riskCapacityScore,
        riskPreferenceScore,
      });
      this.dualNotchCaluculation({
        min: 0,
        max: 100,
        riskCapacityScore,
        riskPreferenceScore,
      });
    }
  }

  componentWillReceiveProps(nextProps) {
    const {
      min,
      max,
      value,
      percentage,
      dualNotch,
      riskCapacityScore,
      riskPreferenceScore,
    } = nextProps;

    this.caluculation({ min: min * 1, max: max * 1, value: value * 1 });
    this.dualNotchCaluculation({
      min: 0,
      max: 100,
      riskCapacityScore,
      riskPreferenceScore,
    });

    if (this.props.percentage && percentage !== this.props.percentage) {
      let slider_color = this.getSliderColorIndex({ percentage });
      this.setState({
        percentage,
        slider_color,
      });
    }

    if (dualNotch) {
      this.setState({
        riskCapacityScore,
        riskPreferenceScore,
      });
    }
  }

  perCalc = ({ min, max, value }) => {
    let range = max - min;
    let per = ((value - min) * 100) / range;
    return per;
  };

  getSliderColorIndex = ({ percentage }) => {
    let slider_color = 0;

    if (percentage) {
      if (percentage <= 20) {
        slider_color = 0;
      } else if (percentage > 20 && percentage <= 40) {
        slider_color = 1;
      } else if (percentage > 40 && percentage <= 60) {
        slider_color = 2;
      } else if (percentage > 60 && percentage <= 80) {
        slider_color = 3;
      } else if (percentage > 80) {
        slider_color = 4;
      } else {
        slider_color = 0;
      }
    }
    return slider_color;
  };
  caluculation = ({ min, max, value }) => {
    let percentage = this.perCalc({ min, max, value });
    let slider_color = this.getSliderColorIndex({ percentage });

    this.setState({
      percentage,
      slider_color,
    });
  };

  dualNotchCaluculation = ({
    min,
    max,
    riskCapacityScore,
    riskPreferenceScore,
  }) => {
    let riskCapacityPercentage = this.perCalc({
      min,
      max,
      value: riskCapacityScore,
    });
    let riskPreferencePercentage = this.perCalc({
      min,
      max,
      value: riskPreferenceScore,
    });

    let riskCapacityColor = this.getSliderColorIndex({
      percentage: riskCapacityPercentage,
    });
    let riskPreferenceColor = this.getSliderColorIndex({
      percentage: riskPreferencePercentage,
    });
    this.setState({
      riskCapacityPercentage,
      riskPreferencePercentage,
      riskCapacityColor,
      riskPreferenceColor,
    });
  };
  render() {
    const {
      colors,
      percentage,
      slider_color,
      rangecolors,
      riskCapacityPercentage,
      riskPreferencePercentage,
    } = this.state;
    const {
      value,
      dualNotch,
      riskCapacityScore,
      riskPreferenceScore,
      topNotch,
    } = this.props;
    let min_val = `${Math.min(
      riskCapacityPercentage,
      riskPreferencePercentage
    )}%  - ${riskCapacityScore > riskPreferenceScore ? "15px" : "45px"}`;
    let difference_val = Math.abs(
      riskCapacityPercentage - riskPreferencePercentage
    );

    return (
      <div className="riskometer">
        <div className="riskometer_c1">Risk Level</div>
        <div className="riskometer_c2">
          {/* top notch  */}
          {topNotch ? (
            <div
              className="riskometer_c2_slider__triangle_down"
              style={{
                // borderBottom: `15px solid ${rangecolors[slider_color]}`,
                marginLeft: `calc(${percentage}% - ${
                  percentage === 0 ? 0 : 30
                }px`,
              }}
              title={`Risk Level of selected model portfolio`}
            />
          ) : null}
          <div className="riskometer_c2_labels">
            <div
              style={{ backgroundColor: colors[0] }}
              className="riskometer_c2_labels_white"
            >
              Low
            </div>
            <div style={{ backgroundColor: colors[1] }}>Moderate Low </div>
            <div style={{ backgroundColor: colors[2] }}>Moderate </div>
            <div
              style={{ backgroundColor: colors[3] }}
              className="riskometer_c2_labels_white"
            >
              Moderate High
            </div>
            <div
              style={{ backgroundColor: colors[4] }}
              className="riskometer_c2_labels_white"
            >
              High
            </div>
          </div>
          <div className="riskometer_c2_slider">
            <div className="riskometer_c2_slider__ruler">
              {Array.from(Array(10).keys()).map((e) => (
                <div className="cm" key={e}>
                  {Array.from(Array(20).keys()).map((d) => (
                    <div className="mm" key={`key-${d}`}></div>
                  ))}
                </div>
              ))}
            </div>

            {dualNotch ? (
              <div className="dualNotchHolder">
                <div
                  className="riskometer_c2_slider__triangle-up"
                  style={{
                    borderBottom: `15px solid #000000`,
                    // borderBottom: `15px solid ${rangecolors[slider_color]}`,
                    left: `calc(${riskCapacityPercentage}% - ${
                      riskCapacityPercentage === 100 ? "30px" : "0px"
                    }`,
                  }}
                  title={`Risk Capacity : ${riskCapacityPercentage}`}
                ></div>

                <div
                  className="riskometer_c2_slider__triangle-up"
                  style={{
                    borderBottom: `15px solid #000000cc`,
                    // borderBottom: `15px solid ${rangecolors[slider_color]}`,
                    left: `calc(${riskPreferencePercentage}% - ${
                      riskPreferencePercentage === 0
                        ? "30px"
                        : riskPreferencePercentage === 100
                        ? "60px"
                        : "0px"
                    }`,
                  }}
                  title={`Risk Preference : ${riskPreferencePercentage}`}
                ></div>
                <div
                  className="dualNotchHolder__transparent_indicator"
                  style={{
                    position: "relative",
                    left: `calc(${min_val})`,
                    width: `calc(${difference_val}% ${
                      riskCapacityScore > riskPreferenceScore
                        ? "- 30px"
                        : "+ 30px"
                    })`,
                  }}
                ></div>
              </div>
            ) : (
              <div
                className="riskometer_c2_slider__triangle-up"
                style={{
                  borderBottom: `15px solid ${rangecolors[slider_color]}`,
                  marginLeft: `calc(${percentage}% - ${
                    percentage === 0 ? 0 : 30
                  }px`,
                }}
                title={`${value}%`}
              ></div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

RiskRangeChart.propTypes = {
  min: PropTypes.number,
  max: PropTypes.number,
  value: PropTypes.number,
  dualNotch: PropTypes.bool,
  topNotch: PropTypes.bool,
};

export default RiskRangeChart;



// WEBPACK FOOTER //
// ./src/components/common/riskRangeChart/RiskRangeChart.jsx